import type { TranscriptionLanguage } from "@/common/types/transcriptionLanguage";
import { getTranscriptionLanguages as getTranscriptionLanguagesService } from "@/services/transcriptionLanguages";
import { create } from "zustand";

export interface TranscriptionLanguagesState {
  transcriptionLanguages: TranscriptionLanguage[];
  loading: boolean;
  error: boolean;
  fetchTranscriptionLanguages: () => Promise<void>;
}

export const useTranscriptionLanguagesStore =
  create<TranscriptionLanguagesState>()((set) => ({
    transcriptionLanguages: [],
    loading: false,
    error: false,
    fetchTranscriptionLanguages: async (): Promise<void> => {
      set({ loading: true, error: false });
      try {
        const transcriptionLanguages = await getTranscriptionLanguagesService();
        set({ transcriptionLanguages, loading: false });
      } catch {
        set({ transcriptionLanguages: [], loading: false, error: true });
      }
    },
  }));
